import { Injectable } from '@angular/core';
import { Filesystem, Directory } from '@capacitor/filesystem';

@Injectable({ providedIn: 'root' })
export class DirectorySize {
  async directorySize(directory: any): Promise<number> {
    if (typeof directory === 'string') {
      return this.sizeByPath(directory);
    }
    return 0;
  }

  private async sizeByPath(path: string): Promise<number> {
    try {
      const stat = await Filesystem.stat({ path, directory: Directory.Data });
      if (stat.type === 'file') {
        return stat.size || 0;
      }
      const { files } = await Filesystem.readdir({ path, directory: Directory.Data });
      const sizes = await Promise.all(
        files.map(f => this.sizeByPath(`${path}/${f.name}`))
      );
      return sizes.reduce((sum, s) => sum + s, 0);
    } catch {
      return 0;
    }
  }
}
